/**
 * Environment utilities for resolving API base URL
 * In production, uses window.location.origin so a single build works on any domain
 */

const DEFAULT_API_FALLBACK = "http://localhost:8000";

const trimTrailingSlash = (value: string): string => value.replace(/\/+$/, "");

const normalizeEnvValue = (value?: string): string | undefined => {
  const trimmed = value?.trim();
  return trimmed ? trimTrailingSlash(trimmed) : undefined;
};

export function resolveApiBaseUrl(): string {
  // Use VITE_API_HOST as the primary source for API URL
  const apiHost = normalizeEnvValue(import.meta.env.VITE_API_HOST);

  // In local development we always rely on the explicit host override
  if (import.meta.env.DEV) {
    if (apiHost) {
      return apiHost;
    }
    return DEFAULT_API_FALLBACK;
  }

  // In production builds we should always honor the window origin so a single
  // build can be deployed to any domain without reconfiguration
  const origin =
    typeof window !== "undefined" ? window.location.origin : undefined;
  if (origin && import.meta.env.PROD) {
    return trimTrailingSlash(origin);
  }

  // For SSR/test environments fall back to the explicit host when provided
  if (apiHost) {
    return apiHost;
  }

  // Final fallback for development/testing
  return DEFAULT_API_FALLBACK;
}
